import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const apiKey = process.env.REACT_APP_API_KEY;

export default function AddUser() {
  const API_URL = BASE_URL + "/adduser";
  const navigate = useNavigate();
  const [role, setRole] = useState("");
  const [sportCategory, setSportCategory] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    const name = formData.get("username");
    const email = formData.get("email");
    const password = formData.get("password");

    if (!name || !email || !password || !role) {
      toast.error("All fields are required!");
      return;
    }

    if (role === "Coach" && !sportCategory) {
      toast.error("Please select a sport category for Coach!");
      return;
    }

    const data = {
      Role: role,
      Name: name,
      Email: email,
      Password: password,
      ...(role === "Coach" && { SportCategory: sportCategory }),
    };

    axios
      .post(API_URL, data, {
        headers: {
          Authorization: apiKey,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        // show message returned from backend
        toast.success(res.data.message);
        if (res.status === 200) {
          navigate("/users");
        }
      })
      .catch((error) => {
        // backend may return error message
        const errMsg =
          error.response?.data?.message || "Failed to create user!";
        toast.error(errMsg);
        console.log(error);
      });
  };

  return (
    <div className="container">
      <ToastContainer />
      <h2>Add New User</h2>
      <br />
      <form onSubmit={handleSubmit}>
        <div className="row mb-3">
          <div className="col-sm-6">
            <input
              type="text"
              placeholder="Enter User Name"
              className="form-control"
              name="username"
              required
            />
          </div>
          <div className="col-sm-6">
            <input
              type="email"
              placeholder="Enter Email Here"
              className="form-control"
              name="email"
              required
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-sm-6">
            <select
              className="form-control"
              name="role"
              required
              value={role}
              onChange={(e) => setRole(e.target.value)}
            >
              <option value="" disabled>
                Select Role
              </option>
              <option value="Administrator">Administrator</option>
              <option value="Coach">Coach</option>
            </select>
          </div>
          <div className="col-sm-6">
            <input
              type="password"
              placeholder="Enter Password (8-20 characters)"
              className="form-control"
              name="password"
              required
            />
          </div>
        </div>

        {role === "Coach" && (
          <div className="row mb-3">
            <div className="col-sm-6">
              <select
                className="form-control"
                name="sportcategory"
                value={sportCategory}
                onChange={(e) => setSportCategory(e.target.value)}
                required
              >
                <option value="" disabled>
                  Select Sport Category
                </option>
                <option value="Baseball">Baseball</option>
                <option value="Basketball">Basketball</option>
                <option value="Football">Football</option>
                <option value="Soccer">Soccer</option>
                <option value="Hockey">Hockey</option>
              </select>
            </div>
          </div>
        )}

        <div className="row">
          <div className="col-sm-6">
            <button className="btn btn-primary">Create User</button>
          </div>
        </div>
      </form>
    </div>
  );
}
